/* global $ */
'use strict';

function I18n(EVENTS, MODALS) {
	require('i18next-client/i18next.commonjs.withJQuery');

	var page = require('page');
	var PubSub = require('pubsub-js');
	var handlebarsHelpers = require('./handlebarsHelpers.js');
	var treatmentGallery = require('./treatmentGallery.js');
	var slickGallery = require('./slickGallery.js');
	var errorMessages = require('./errorMessages.js');
	var navigation = require('./navigation.js');
	var loader = require('./loader.js');


	$.i18n.init({
			useCookie: false,
			load: 'current',
			lng: window.NIKE.locale || 'en-GB',
			fallbackLng: 'en-GB',
			resGetPath: 'campaigns/' + window.NIKE.campaign + '/__lng__.json'
		})
		.fail(function () {
			if (window.location.hash !== '#!/campaign/' + window.NIKE.campaign + '/gb/en') {
				var wrongLocale = window.NIKE.locale;
				var wrongLocaleArray = wrongLocale.split('-');
				if (window.NIKE.campaignsParam.defaultCountryLang[wrongLocaleArray[0]]) {
					window.NIKE.country = window.NIKE.campaignsParam.defaultCountryLang[wrongLocaleArray[0]];
					window.NIKE.lang = wrongLocaleArray[0];
					page.redirect('/campaign/' + window.NIKE.campaign + '/' + window.NIKE.country + '/' + window.NIKE.lang);
				} else {
					page.redirect('/campaign/' + window.NIKE.campaign + '/gb/en');
				}
			} else {
				navigation(null, null);
				PubSub.publish(EVENTS.PAGE_ENTER, 'notfound');
				console.log('Can not load current campaign');
				return false;
			}
		})
		.done(function () {
			$('html').attr({'lang': window.NIKE.lang}).addClass($.t('dir'));
			$('body').i18n();
			navigation($.t('nikeFooter.lang'), $.t('nikeFooter.country'));
			handlebarsHelpers();
			errorMessages();
			treatmentGallery(EVENTS);
			slickGallery(EVENTS, MODALS);
			PubSub.publish(EVENTS.PAGE_ENTER);
			loader(EVENTS);
		});
}

module.exports = I18n;
